import React, { useContext } from "react";

// Context
import AppContext from "./AppContext";

// Css
import "./Tool.css";

// Material Ui
// #Icons
import FormatBoldIcon from "@material-ui/icons/FormatBold";
import FormatItalicIcon from "@material-ui/icons/FormatItalic";
import FormatUnderlinedIcon from "@material-ui/icons/FormatUnderlined";
import StrikethroughSIcon from "@material-ui/icons/StrikethroughS";
// #Transitions
import Zoom from "@material-ui/core/Zoom";

function Tool({ buttonType, zoomDelay }) {
  const { appContext } = useContext(AppContext);
  const { textFocus } = appContext;
  const runCommand = (typeOfCommand, e) => {
    document.querySelector(".textEditor").focus();
    document.execCommand(typeOfCommand, false, null);
  };

  let tool_icon;
  let tool_title;
  switch (buttonType) {
    case "bold":
      tool_icon = <FormatBoldIcon />;
      tool_title = "Bold";
      break;
    case "italic":
      tool_icon = <FormatItalicIcon />;
      tool_title = "Italic";
      break;
    case "underline":
      tool_icon = <FormatUnderlinedIcon />;
      tool_title = "Underline";
      break;
    case "strikeThrough":
      tool_icon = <StrikethroughSIcon />;
      tool_title = "Strike";
      break;
    default:
  }

  return (
    <div>
      <Zoom in={!textFocus} style={{ transitionDelay: zoomDelay }}>
        <button
          className="tool"
          id={`tool__${buttonType}`}
          onClick={() => {
            runCommand(buttonType);
          }}
        >
          {tool_icon}
          <span className="tool__title">{tool_title}</span>
        </button>
      </Zoom>
    </div>
  );
}

export default Tool;
